module.exports = __webpack_public_path__ + "static/media/yellow-lamp.471309e4.jpg";